import React, { useState } from 'react';
import PropTypes from 'prop-types';
import InputBase from '@mui/material/InputBase';
import FormControl from '@mui/material/FormControl';
import InputAdornment from '@mui/material/InputAdornment';
import ErrorIcon from '@mui/icons-material/Error';
import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';

export default function QboTextField({
  id,
  label,
  name,
  disabled,
  errorMessage,
  placeholder,
  startIcon,
  endIcon,
  helperText,
  fullWidth,
  withoutErrorIcon,
  isPasswordField,
  ...rest
}) {
  const inputAttributes = {};
  let error = false;

  const [isPasswordVisible, setPasswordVisible] = useState(false);

  if (name) inputAttributes.name = name;
  if (placeholder) inputAttributes.placeholder = placeholder;
  if (errorMessage) error = true;

  if (startIcon) {
    inputAttributes.startAdornment = <InputAdornment position="start">{startIcon}</InputAdornment>;
  }

  if (endIcon) {
    inputAttributes.endAdornment = <InputAdornment position="end">{endIcon}</InputAdornment>;
  }

  if (isPasswordField) {
    if (isPasswordVisible) {
      inputAttributes.type = 'text';
      inputAttributes.endAdornment = (
        <InputAdornment
          position="end"
          className="QboTextField__password-visible-icon"
          onClick={() => {
            setPasswordVisible(false);
          }}>
          <VisibilityOffOutlinedIcon />
        </InputAdornment>
      );
    } else {
      inputAttributes.type = 'password';
      inputAttributes.endAdornment = (
        <InputAdornment
          position="end"
          className="QboTextField__password-visible-icon"
          onClick={() => {
            setPasswordVisible(true);
          }}>
          <RemoveRedEyeOutlinedIcon />
        </InputAdornment>
      );
    }
  }

  if (rest?.endAdornment) {
    inputAttributes.endAdornment = rest?.endAdornment;
  }

  return (
    <FormControl
      className={`FormControl__default-wrapper ${
        fullWidth ? 'FormControl__full-width-wrapper' : ''
      }`}
      disabled={disabled}
      error={error}>
      {label && (
        <label className="QboTextField__label" htmlFor={`#${id}`}>
          {label}
        </label>
      )}

      <InputBase id={id} {...inputAttributes} {...rest} />

      {helperText && !errorMessage && (
        <span className="QboTextField__helper-text">{helperText}</span>
      )}

      {errorMessage && (
        <span className="QboTextField__error-text">
          {!withoutErrorIcon && <ErrorIcon />}
          {` ${errorMessage}`}
        </span>
      )}
    </FormControl>
  );
}

QboTextField.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.string,
  disabled: PropTypes.bool,
  errorMessage: PropTypes.string,
  placeholder: PropTypes.string,
  startIcon: PropTypes.node,
  endIcon: PropTypes.node,
  helperText: PropTypes.string,
  fullWidth: PropTypes.bool,
  withoutErrorIcon: PropTypes.bool,
  isPasswordField: PropTypes.bool,
};

QboTextField.defaultProps = {
  id: '',
  name: '',
  label: null,
  disabled: false,
  errorMessage: null,
  placeholder: null,
  startIcon: null,
  endIcon: null,
  helperText: null,
  fullWidth: false,
  withoutErrorIcon: false,
  isPasswordField: false,
};
